<template>
  <section id="members">
    <div class="row text-center">
      <div class="col">
        <h2 class="title">
          Members
          <hr class="divider">
        </h2>
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <h6 class="subtitle">
          This is Recogna's team, which counts with students and professors from several
          institutions.
        </h6>
      </div>
    </div>
    <div class="row text-center mt-5">
      <div class="col">
        <h6 class="title">
          Main Researchers
        </h6>
      </div>
    </div>
    <div class="row text-center mt-4 d-flex justify-content-center">
      <div
        v-for="researcher in researchers"
        :key="researcher.id"
        class="col mb-5"
      >
        <a
          :href="researcher.url"
          target="_blank"
        >
          <b-img
            class="mb-2"
            :src="getMemberImage(researcher.img)"
            width="150px"
            thumbnail
            fluid
          />
        </a>
        <h6>
          {{ researcher.name }}
        </h6>
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <h6 class="title">
          Collaborators
        </h6>
      </div>
    </div>
    <div class="row text-center mt-4 d-flex justify-content-center">
      <div
        v-for="collaborator in collaborators"
        :key="collaborator.id"
        class="col-6 col-sm-4 col-lg-2 mb-5"
      >
        <a
          :href="collaborator.url"
          target="_blank"
        >
          <b-img
            class="mb-2"
            :src="getMemberImage(collaborator.img)"
            width="100px"
            thumbnail
            fluid
          />
        </a>
        <h6>
          {{ collaborator.name }}
        </h6>
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <h6 class="title">
          Post-doctoral Researchers
        </h6>
      </div>
    </div>
    <div class="row text-center mt-4 d-flex justify-content-center">
      <div
        v-for="postphd in postphds"
        :key="postphd.id"
        class="col-6 col-sm-4 col-lg-3 mb-5"
      >
        <a
          :href="postphd.url"
          target="_blank"
        >
          <b-img
            class="mb-2"
            :src="getMemberImage(postphd.img)"
            width="100px"
            thumbnail
            fluid
          />
        </a>
        <h6>
          {{ postphd.name }}
        </h6>
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <h6 class="title">
          Students
        </h6>
      </div>
    </div>
    <div class="row text-center mt-4 d-flex justify-content-center">
      <div
        v-for="student in students"
        :key="student.id"
        class="col-6 col-sm-4 col-lg-2 mb-5"
      >
        <a
          :href="student.url"
          target="_blank"
        >
          <b-img
            class="mb-2"
            :src="getMemberImage(student.img)"
            width="100px"
            thumbnail
            fluid
          />
        </a>
        <h6 class="mb-0">
          {{ student.name }}
        </h6>
        <span class="small text-muted">
          {{ student.title }}
        </span>
      </div>
    </div>


    <div class="row text-center">
      <div class="col">
        <h6 class="title">
          Alumni
        </h6>
      </div>
    </div>
    <div class="row text-center mt-4 d-flex justify-content-center">
      <div
        v-for="pastStudent in alumni"
        :key="pastStudent.id"
        class="col-6 col-sm-4 col-lg-2 mb-5"
      >
        <b-img
          class="mb-2"
          :src="getMemberImage(pastStudent.img)"
          width="100px"
          thumbnail
          fluid
        />
        <h6>
          {{ pastStudent.name }}
        </h6>
      </div>
    </div>
  </section>
</template>

<script>
import { researchers, collaborators, postphds, students, alumni } from '@/configs/members'

export default {
    name: 'OurMembers',
    data() {
        return {
            researchers: researchers,
            collaborators: collaborators,
            postphds: postphds,
            students: students,
            alumni: alumni
        }
    },
    methods: {
        getMemberImage(image) {
            return require('../assets/img/members/' + image)
        }
    }
}
</script>